import { render, staticRenderFns } from "./Mesas.vue?vue&type=template&id=0f37fd0a&scoped=true&"
import script from "./Mesas.vue?vue&type=script&lang=js&"
export * from "./Mesas.vue?vue&type=script&lang=js&"
import style0 from "./Mesas.vue?vue&type=style&index=0&id=0f37fd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f37fd0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VDialog,VRow,VSelect})
